import { render, staticRenderFns } from "./roleForm.vue?vue&type=template&id=572d05f3&"
import script from "./roleForm.vue?vue&type=script&lang=js&"
export * from "./roleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports